//  zadrži subdomene iz configa (npr. "server.rocketman" ili "chat"),
//  zadrži protokol i port; zameni SAMO bazni domen na osnovu FE hosta.
export const getBaseDomain = (host) => {
  const parts = (host || '').split('.').filter(Boolean);
  return parts.length >= 2 ? parts.slice(-2).join('.') : host || '';
};

const getConfiguredSubprefix = (host) => {
  const parts = (host || '').split('.').filter(Boolean);
  // sve sem poslednja 2 su subdomenski prefiks (npr. ["server","rocketman"])
  return parts.length > 2 ? parts.slice(0, -2).join('.') : parts.slice(0, -2).join('.');
};

export const makeDynamicUrlPreserveProtoPort = (configuredUrl) => {
  try {
    // localhost bypass – koristi config kakav jeste
    if (typeof window !== 'undefined') {
      const feHost = window.location.hostname;
      if (feHost === 'localhost' || feHost === '127.0.0.1') {
        return configuredUrl;
      }
    } else {
      return configuredUrl;
    }

    const u = new URL(configuredUrl);
    const feBase = getBaseDomain(window.location.hostname); // npr. "nvsmy22pj8.click"
    const subprefix = getConfiguredSubprefix(u.hostname);   // npr. "server.rocketman" ili "chat"
    const newHost = subprefix ? `${subprefix}.${feBase}` : feBase;

    u.hostname = newHost;
    // čuvamo sve: protokol, port, path, query, hash:
    return u.toString();
  } catch {
    return configuredUrl; // fallback
  }
};
